import axios, { AxiosInstance, AxiosResponse } from 'axios';

class ScoreReflectClient {
  private client: AxiosInstance;
  
  constructor() {
    this.client = axios.create({
      baseURL: 'https://scoreflect.ru/api/v1',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  async request(method: string, params: any = {}): Promise<AxiosResponse<any, any>> {
    return await this.client.post(method, params);
  }
}

export default new ScoreReflectClient();